import { FC } from 'react'
import { SvgProps } from './svgProps'

const ArrowUpIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 12}
    height={height || 9}
    viewBox="0 0 12 9"
  >
    <defs>
      <filter id="x9x9b2sela" colorInterpolationFilters="auto">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity=".538"
    >
      <g
        filter="url(#x9x9b2sela)"
        transform="translate(-175.000000, -175.000000)"
      >
        <path
          stroke={color || '#FFF'}
          strokeWidth="1.5"
          d="M7.8 0.9L4.2 4.5 7.8 8.1"
          transform="translate(181.000000, 179.500000) scale(1, -1) translate(-181.000000, -179.500000) translate(175.000000, 175.000000) translate(6.000000, 4.500000) scale(1, -1) rotate(90.000000) translate(-6.000000, -4.500000)"
        />
      </g>
    </g>
  </svg>
)

export default ArrowUpIcon
